import Device from '../../utils/device';

export default {
  name: 'device',
  proto: {
    device: Device,
  },
  static: {
    device: Device,
  },
};



// WEBPACK FOOTER //
// ../src/modules/device/device.js